<template>
    <v-container>
        <v-layout>
            <v-flex>
                <v-tooltip top>
                    <v-btn
                            class="mr-2 mb-2"
                            @click="newCovidPatientEvolution"
                            color="customPurple"
                            dark
                            fixed
                            bottom
                            right
                            fab
                            slot="activator"
                    >
                        <v-icon>add</v-icon>
                    </v-btn>
                    <span>Registro de Evolución</span>
                </v-tooltip>
                <div>
                    <v-layout>
                        <v-flex xs12 sm6 offset-sm6>
                            <v-text-field
                                    v-model="search"
                                    append-icon="search"
                                    label="Buscar"
                                    single-line
                                    hide-details
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </div>
            </v-flex>
            <v-dialog
                    v-model="dialog"
                    fullscreen hide-overlay transition="dialog-bottom-transition"
                    scrollable>
                <v-card tile>
                    <v-toolbar card dark color="nav_background_color">
                        <v-btn icon dark @click.native="dialog = false" @click="cleanData">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Nueva Evolución</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>                            
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <table align="center" width="100%" bgcolor="#E0E0E0">
                                        <tbody>
                                        <tr>
                                            <td>
                                                <b>Paciente:</b>
                                                {{this.$store.state.covidPatient.lastName}} {{this.$store.state.covidPatient.name}}
                                            </td>
                                            <td>
                                                <b>Identificación:</b>
                                                {{this.$store.state.covidPatient.identification}}
                                            </td>
                                            <td>
                                                <b>Teléfono:</b>
                                            </td>
                                            <td>{{this.$store.state.covidPatient.phone}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </v-flex>
                            </v-layout>
                            </br>
                            <v-layout>                                
                                <v-flex xs12 sm10 offset-sm1>
                                    <p class="font-weight-bold">Evolución</p>
                                    <v-textarea
                                            v-model="covidPatientEvolution.evolution"
                                            :rules="[v => !!v || 'El campo es requerido']"
                                            required
                                            maxlength="20000"
                                    ></v-textarea>
                                </v-flex>
                            </v-layout>
                            <v-layout v-if="this.$store.state.covidPatient.status=='INACTIVO'">
                                <v-flex xs12 sm10 offset-sm1>
                                    <p class="font-weight-bold">Estado</p>
                                    <v-select
                                            v-model="covidPatientEvolution.status"
                                            :items="this.itemsStatus"
                                            :rules="[v => !!v || 'El campo es requerido']"
                                            return-object
                                            required
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm6 offset-sm4>
                                    <div>
                                        <v-btn :disabled="!valid"
                                               @click="saveData" large color="primary">Guardar
                                        </v-btn>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-card-text>
                    <div style="flex: 1 1 auto;"></div>
                </v-card>
            </v-dialog>
        </v-layout>
        <h3 class="primary--text">Evolución de paciente</h3>
        <v-data-table
                :headers="headers"
                :items="covidPatientEvolutionList"
                class="elevation-1"
                sort-icon="mdi-menu-down"
                :search="search"
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs-left" :style="getColor(props.item.status)">{{ props.item.covidPatient.lastName }} {{ props.item.covidPatient.name }}</td>
                <td class="text-xs-left" :style="getColor(props.item.status)">{{ props.item.covidPatient.identification }}</td>
                <td class="text-xs-left" :style="getColor(props.item.status)">{{ getFormattedDate(props.item.date) }}</td>
                <td class="text-xs-left" :style="getColor(props.item.status)">{{ props.item.evolution }}</td>
                <td class="text-xs-left" :style="getColor(props.item.status)" v-if="props.item.user!=null">{{ props.item.user.firstName}}
                    {{props.item.user.lastName}}
                </td>
                <td class="text-xs-left" v-else :style="getColor(props.item.status)"></td>
                <td class="text-xs-left" :style="getColor(props.item.status)">{{ props.item.status!=''? props.item.status:'N/A'}}</td>


                <td :style="getColor(props.item.status)">
                    <v-tooltip top>
                        <v-btn
                                fab dark
                                small @click="editItem(props.item)"
                                slot="activator"
                                color="primary">
                            <v-icon dark>edit</v-icon>
                        </v-btn>
                        <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <v-btn fab dark small @click="deleteItem(props.item)" slot="activator" color="primary">
                            <v-icon dark>delete</v-icon>
                        </v-btn>
                        <span>Eliminar</span>
                    </v-tooltip>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                No se han encontrado resultados para "{{ search }}".
            </v-alert>
        </v-data-table>
    </v-container>
</template>
<script>
    import CovidPatient from "../../model/CovidPatient";
    import CovidPatientAlarm from "../../model/CovidPatientAlarm";
    import CovidPatientEvolution from "../../model/CovidPatientEvolution";

    export default {
        data() {
            return {
                search: '',
                valid: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                statusItems: ['ACTIVO',
                    'INACTIVO'],
                itemsElements: ['SI', 'NO'],
                itemsStatus: ['N/A', 'BLANCO', 'AMARILLO', 'ROJO' ],
                headers: [
                    {text: 'Paciente', value: 'covidPatient.lastName'},
                    {text: 'Identificación', value: 'covidPatient.idnetification'},
                    {text: 'Fecha registro', value: 'date'},
                    {text: 'Evolución', value: 'evolution'},
                    {text: 'Usuario creación', value: 'user.lastName'},
                    {text: 'Estado Evolución', value: 'status'},
                    {text: 'Opciones', value: 'options'}

                ],
                editedIndex: -1,
                covidPatientEvolution: new CovidPatientEvolution(),
                covidPatientEvolutionList: []                
            };
        },
        methods: {
            cleanData() {
                this.$refs.form.reset();
                this.covidPatientEvolution = new CovidPatientEvolution();
                this.valid = false;
                this.dialog = false;
            },
            newCovidPatientEvolution() {
                this.editedIndex = -1;
                this.valid = false;
                this.dialog = true;
                this.$refs.form.reset();
                this.covidPatientEvolution = new CovidPatientEvolution();                
            },
            saveData() {
                if (this.$refs.form.validate()) {
                    if (this.covidPatientEvolution.status == 'N/A' || this.covidPatientEvolution.status=="") {
                        this.covidPatientEvolution.status = null
                    }
                    if (this.editedIndex > -1) {
                        this.covidPatientEvolution.user = this.$store.state.userInSession
                        this.covidPatientEvolution.user.company = null
                        this.$store.dispatch('updateCovidPatientEvolution', this.covidPatientEvolution).then(
                            response => {
                                this.loadData();
                                this.cleanData();
                            },
                            error => {
                                this.$store.state.progress = false;
                                this.$store.state.dialogError = true;
                                this.$store.state.dialogErrorMessage = 'No se pudo modificar la evoluciòn'
                            }
                        );
                    } else {
                        this.covidPatientEvolution.user = this.$store.state.userInSession
                        this.covidPatientEvolution.user.company = null
                        this.covidPatientEvolution.date = new Date()
                        this.covidPatientEvolution.covidPatient = this.$store.state.covidPatient
                        this.$store.dispatch('addCovidPatientEvolution', this.covidPatientEvolution).then(
                            response => {
                                this.loadData();
                                this.cleanData();
                            },
                            error => {
                                this.$store.state.progress = false;
                                this.$store.state.dialogError = true;
                                this.$store.state.dialogErrorMessage = 'No se pudo crear la evolución'
                            }
                        );
                    }
                    this.dialog = false;
                }
            },
            editItem(item) {
                this.editedIndex = this.covidPatientEvolutionList.indexOf(item);                
                this.covidPatientEvolution = Object.assign({}, item);
                this.dialog = true;
            },
            deleteItem(item) {
                this.editedIndex = this.covidPatientEvolutionList.indexOf(item);
                this.covidPatientEvolution = Object.assign({}, item);
                confirm('Está seguro de que quiere eliminar el registro?') &&
                this.$store.dispatch('deleteCovidPatientEvolution', this.covidPatientEvolution.id).then(response => {
                    this.loadData()
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },
            loadData() {
                this.$store.dispatch('getCovidPatientEvolutionsByPatient', this.$store.state.covidPatient.id).then(
                    response => {
                        this.covidPatientEvolutionList = response.data                        
                        this.cleanData();
                    },
                    error => {
                        this.$store.state.dialogError = true;
                    }
                );
            },            
            getFormattedDate(dateReg) {
                var ua = navigator.userAgent.toLowerCase();
                var date;
                if (true) {
                    // Para Safari
                    if (!(dateReg instanceof Date)) {
                        var b = dateReg.toString().split(/\D/);
                        date = new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5]));
                    } else {
                        date = new Date(dateReg);
                    }
                } else {
                    // Otros navegadores
                    date = new Date(dateReg);
                }
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var min = date.getMinutes();
                var sec = date.getSeconds();
                month = (month < 10 ? "0" : "") + month;
                day = (day < 10 ? "0" : "") + day;
                hour = (hour < 10 ? "0" : "") + hour;
                min = (min < 10 ? "0" : "") + min;
                sec = (sec < 10 ? "0" : "") + sec;
                var str = date.getFullYear() + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;
                return str;
            },

            getColor(item){
                if(item=="ROJO" ){
                    return "background-color: #F08080"
                }else if(item=="AMARILLO" ){
                    return "background-color: yellow"
                }else{
                    return "background-color: white"
                }
            },
        },
        computed: {},
        created() {
            this.loadData()            
        }
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/covid/CovidPatientEvolution.vue